import { SolidViewLayoutManager } from "@solidstarters/solid-core-ui";
import { getSession } from "next-auth/react";
import axios from "axios";
import qs from "qs";


let vesselOption: Record<string, any> = {};

const vesselDataFormLoad = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata, formData } = event;
    // console.log("Event triggered:", modifiedField, modifiedFieldValue);
    const session: any = await fetchUser();
    const API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL;
    const token = session?.user?.accessToken || "";
    const layoutManager = new SolidViewLayoutManager(viewMetadata.layout);
    const newFormData: any = {};

    if (["line", "location", "vessel"].includes(event.modifiedField)) {

        const formValues = event?.formData || {};

        // If modified field is line, location, or vessel, fetch the value from modifiedFieldValue else from formData
        const line = modifiedField === 'line' ? modifiedFieldValue?.value : formValues?.line?.value;
        const location = modifiedField === 'location' ? modifiedFieldValue?.value : formValues?.location?.value;
        const vessel = modifiedField === 'vessel' ? modifiedFieldValue?.value : formValues?.vessel?.value;

        // Create the filters depending on the line, location, vessel values in the form values
        const paginationQueryDto = {
            limit: 100,
            offset: 0,
        };

        const filters: any = {};
        if (line) {
            filters.line = { $eq: line };
        }
        if (location) {
            filters.location = { $eq: location };
        }
        if (vessel) {
            filters.vessel = { $eq: vessel };
        }
 
        const queryFilter = {
            filters,
            ...paginationQueryDto,
        };
        const queryString = qs.stringify(queryFilter, {
            encodeValuesOnly: true,
        });

        const response = await axios.get(`${API_URL}/api/voyage-master?${queryString}`, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });


        const voyageRecords = response.data?.data?.records || [];
        // console.log(voyageRecords,'voyageRecords');

        if (voyageRecords.length === 1) {
            const voyage = voyageRecords[0];
            newFormData.voyageNumber = {
                label: voyage?.voyageMasterUserKey,
                value: voyage?.code
            };
            if (formData?.type?.value === 'Import') {
                newFormData.igmNo = voyage.igmNo;
                newFormData.igmDate = voyage.igmDate;
                newFormData.terminal = voyage.terminal;
                newFormData.pcNo = null;
                newFormData.pcDate = null;
            } else if (formData?.type?.value === 'Export') {
                newFormData.pcNo = voyage.pcNo;
                newFormData.pcDate = voyage.pcDate;
                newFormData.terminal = voyage.terminal;
                newFormData.igmNo = null;
                newFormData.igmDate = null;
            } else {
                newFormData.terminal = voyage.terminal;
                newFormData.pcNo = null;
                newFormData.pcDate = null;
                newFormData.igmNo = null;
                newFormData.igmDate = null;
            }
        }
        else {
            // Clear the vessel data
            clearVoyageData(newFormData);
        }
    }


    if (modifiedField === 'voyageNumber') {
        vesselOption['voyageNumber'] = modifiedFieldValue?.value;

        const filters: Record<string, any> = { code: { $eq: vesselOption['voyageNumber'] } };
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value && value.$eq) params.append(`filters[${key}][$eq]`, value.$eq);
        });

        const response = await axios.get(`${API_URL}/api/voyage-master`, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            params
        });

        const voyageRecords = response.data?.data?.records || [];

        if (voyageRecords.length > 0) {
            const voyage = voyageRecords[0];
            if (formData?.type?.value === 'Import') {
                newFormData.igmNo = voyage.igmNo;
                newFormData.igmDate = voyage.igmDate;
                newFormData.terminal = voyage.terminal;
                newFormData.pcNo = null;
                newFormData.pcDate = null;
            } else if (formData?.type?.value === 'Export') {
                newFormData.pcNo = voyage.pcNo;
                newFormData.pcDate = voyage.pcDate;
                newFormData.terminal = voyage.terminal;
                newFormData.igmNo = null;
                newFormData.igmDate = null;
            } else {
                newFormData.terminal = voyage.terminal;
                newFormData.pcNo = null;
                newFormData.pcDate = null;
                newFormData.igmNo = null;
                newFormData.igmDate = null;
            }

        }

    }


    return {
        layoutChanged: true,
        dataChanged: true,
        newLayout: layoutManager.getLayout(),
        newFormData
    };
};



const fetchUser = async () => {
    const session: any = await getSession();
    // console.log("Fetched session:", session);
    return session;
};

function clearVoyageData(formData: Record<string, any>) {
    Object.assign(formData, {
        voyageNumber: null,
        pcNo: null,
        pcDate: null,
        terminal: null,
        igmNo: null,
        igmDate: null,
    });
}

export default vesselDataFormLoad;
